import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import Link from 'components/_utility/Link/Link';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  ${({ isVisible, isBikeZoomed }) => `
  width: 100%;
  background-color: #efeeee;
  position: relative;
  height: 58px;
  margin-bottom: 2px;
  display: ${isVisible ? 'block' : 'none'};
  
  ${
    isBikeZoomed
      ? `
    z-index: 101;
  `
      : ``
  }

  @media ${minBp('desktop')} {
    background-color: white;
    height: 54px;
    min-height: 54px;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`};
`;

export const LeftShade = styled.div`
  position: absolute;
  height: 58px;
  width: 15px;
  top: 0;
  left: 0;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 100%);
  opacity: ${({ visible }) => Number(visible)};
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;

  @media ${minBp('desktop')} {
    display: none;
  }
`;

export const RightShade = styled.div`
  position: absolute;
  height: 58px;
  width: 15px;
  top: 0;
  right: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 100%);
  opacity: ${({ visible }) => Number(visible)};
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;

  @media ${minBp('desktop')} {
    display: none;
  }
`;

export const Scroller = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 10px;
  white-space: nowrap;
  height: 62px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  @media ${minBp('tablet')} {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  @media ${minBp('desktop')} {
    overflow: inherit;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: 1px solid #dedede;
    padding: 0;
    height: 52px;
  }
`;

const stepStyles = css`
  padding: 20px 0 16px;
  margin: 0 10px;
  appearance: none;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: 17px;
  background: transparent;
  border: 0;
  text-decoration: none;
  color: #585a5f;
  display: inline-block;
  position: relative;
  white-space: nowrap;
  text-transform: uppercase;
  cursor: pointer;

  @media ${minBp('desktop')} {
    display: flex;
    height: 52px;
    align-items: center;
    justify-content: center;
    flex: 1;
    margin: 0;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.dinRegular};
    padding: 0;

    &:not(:last-child) {
      border-right: 1px solid #dedede;
    }
  }

  ${({ bold }) =>
    bold
      ? `
      @media ${minBp('desktop')} {
        font-family: ${({ theme }) => theme.fonts.dinDemi};
        color: #000;
      }
  `
      : ``}
`;

const _Button = forwardRef(({ bold, active, ...props }, ref) => <button type="button" ref={ref} {...props} />);

export const Step = styled(_Button)`
  ${stepStyles};

  ${({ active }) =>
    active
      ? `
      color: #000;

      &:after {
        content: ' ';
        width: 100%;
        height: 5px;
        background-color: #cd192d;
        position: absolute;
        bottom: -2px;
        left: 0;
      }

      @media ${minBp('tablet')} {
        &:after {
          bottom: 0;
        }
      }

      @media ${minBp('desktop')} {
        font-family: ${({ theme }) => theme.fonts.dinDemi};


        &:after {
          content: ' ';
          width: 100%;
          height: 4px;
          background-color: #cd192d;
          position: absolute;
          bottom: -1px;
          left: 0;
        }
      }
  `
      : ``}
`;

export const StepLink = styled(Link)`
  ${stepStyles};
`;

export const CheckIcon = styled.span`
  display: none;

  @media ${minBp('desktop')} {
    display: inline-block;
    margin-right: 2px;
    height: 20px;

    svg {
      height: 18px;
    }
  }
`;

export const StepNumber = styled.span`
  margin-right: 4px;

  @media ${minBp('desktop')} {
    display: ${({ check }) => (check ? 'none' : 'inline')};
  }
`;
